const storeLocale = () =>
  (window.Shopify && window.Shopify.locale) || window.activeShop?.shopInfo?.primaryLocale || '';

/**
 * @param locale
 * @returns {string}
 */
export default function convertLocale(locale = storeLocale()) {
  switch (locale) {
    case 'zh-CN':
      return 'zh-chs';
    case 'zh-TW':
      return 'zh-cht';
    case 'ms':
      return 'zsm';
    case 'pt-PT':
    case 'pt-BR':
      return 'pt';
    default:
      return locale;
  }
}
